export default __webpack_public_path__ + "static/media/team.1b811cfd.svg";